import React, { useState } from 'react';
import Question from './GeneralQuestion.jsx';
import "../styles/Template.css";

import Result from './Result.jsx'

function Template(props) {
    const que = props.que;
    const animes = props.animes;
    const [responses, setResponses] = useState({});
    const [showResult, setShowResult] = useState(false);
    const [anime, setAnime] = useState('');

    const handleOptionChange = (questionIndex, option) => {
        setResponses({ ...responses, [questionIndex]: option });
    };

    const calculateResult = () => {
        const categoryCounts = {"A": 0, "B": 0, "C": 0, "D": 0,"E":0,"F":0};

        for (const key in responses) {
            categoryCounts[responses[key]] += 1;
        }

        const dominantCategory = Object.keys(categoryCounts).reduce((a, b) => categoryCounts[a] > categoryCounts[b] ? a : b);
       
        

        setAnime(dominantCategory);
       
        setShowResult(true);
    };



  
    return (
        
        <div className="template">
            
            {!showResult ? (
                <>
                    <h2 className='quiz-heading'>{props.head}</h2>
                    {que.map((q, index) => (
                        <Question
                            key={index}
                            img={q.img}
                            question={q.question}
                            options={q.OPTIONS}
                            questionIndex={index}
                            onOptionChange={handleOptionChange}
                        />
                    ))}
                    <button className='template-button' onClick={calculateResult}>Submit Quiz</button>
                </>
            ) : (
                <Result animes={animes} anime={anime} />
            )}
        </div>
        
    );
}

export default Template;
